import * as React from 'react';
import styles from './header-with-toolbar.scss';

export interface HeaderWithToolbarProps {
  title?: string;
  className?: string;
  headerClassName?: string;
  hasLongDescription?: boolean;
  children?: React.ReactNode;
}

export const HeaderWithRightToolbar: React.FC<HeaderWithToolbarProps> = ({ 
  title, className, headerClassName, hasLongDescription, children }) => {
  
  const titleElement = !!title && <h3 className={className}>{title}</h3>;
  
  return (
    <div className={`row flex-nowrap justify-content-between ${styles.expanderHeader} 
        ${!!title ? 'has-title' : ''}  ${hasLongDescription && styles.longDescriptionTitle} ${headerClassName} dialog-expander-header`}>
      <div className={`col ${styles.title}`}>{titleElement}</div>
      <div className={` col col-auto ${styles.expanderCloseX} expander-close-x`}>
        <div className="d-flex">
          {children}
        </div>
      </div>
    </div>
  );
};
